// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Attachment = function Attachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.506 3.804a2.267 2.267 0 0 0-3.209 0l-6.543 6.55a3.81 3.81 0 0 0 0 5.39 3.815 3.815 0 0 0 5.39 0l5.18-5.186a.819.819 0 0 1 1.156 1.157l-5.18 5.189a5.444 5.444 0 0 1-7.702 0 5.454 5.454 0 0 1-.004-7.71l6.547-6.55a3.907 3.907 0 0 1 5.524 5.523l-6.267 6.27a2.553 2.553 0 0 1-3.802-.211 2.56 2.56 0 0 1 .187-3.405l5.177-5.175a.819.819 0 0 1 1.156 1.156l-5.173 5.179a.915.915 0 0 0-.068 1.221.915.915 0 0 0 1.364.075l6.267-6.267a2.27 2.27 0 0 0 0-3.21z"
  }));
};
